import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { computed } from 'mobx';
import { observer, inject, Observer } from 'mobx-react';

import { Panel, PanelType } from 'office-ui-fabric-react/lib/Panel';

import { localizable } from 'components/Localization';
import PanelFooter from 'components/PanelFooter';

import RoundEdit from './RoundEdit';
import RoundEditStore from './stores/RoundEditStore';

// Modal Panel with RoundEdit component inside

@inject('app', 'sale')
@localizable
@observer
class RoundPanel extends Component {
  static propTypes = {
    isOpen: PropTypes.bool,
    onSave: PropTypes.func,
    onClose: PropTypes.func,
  };

  static defaultProps = {
    isOpen: false,
  };

  store = null; // RoundEditStore

  componentWillMount() {
    const { round, sale } = this.props;
    this.store = new RoundEditStore(
      round,
      sale.saleConfig,
      sale.saleEdit.offerData.timezone
    );
  }

  @computed get isValid() {
    return this.store.isValid;
  }

  handleSave = () => {
    const { onSave } = this.props;
    if (!onSave) return;
    onSave(this.store.saveableRound);
  };

  handleClose = () => {
    const { onClose } = this.props;
    if (onClose) onClose();
  };

  render() {
    const { intl, t } = this.props;
    return (
      <Panel
        headerText={t('Round')}
        type={PanelType.medium}
        isOpen={this.props.isOpen}
        onDismissed={this.handleClose}
        onRenderFooterContent={this.renderPanelFooterContent}
        isFooterAtBottom={true}
        closeButtonAriaLabel={t('Close')}
      >
        <RoundEdit store={this.store} intl={intl} />
      </Panel>
    );
  }

  renderPanelFooterContent = () => {
    const { t } = this.props;
    return (
      <Observer
        render={() => (
          <PanelFooter
            saveBtnLabel={t('Save')}
            closeBtnLabel={t('Cancel')}
            saveDisabled={!this.isValid}
            onSave={this.handleSave}
            onClose={this.handleClose}
          />
        )}
      />
    );
  };
}

export default RoundPanel;



// WEBPACK FOOTER //
// ./src/app/containers/Sale/RoundSection/RoundPanel.jsx